<template>
  <v-expansion-panels v-model="panelOpen">
    <v-expansion-panel class="va-toggle-block" readonly>
      <v-expansion-panel-header>
        <div class="d-flex flex-column">
          <div class="va-toggle-block--title">{{ title }}</div>
          <div class="va-toggle-block--subtitle">{{ subTitle }}</div>
          <div @click="toggleContent" v-if="switchValue" class="va-toggle-block--action">
            <span class="va-toggle-block--action-text">Advanced</span>
            <v-icon :class="[isContentOpen ? 'va-toggle-block--action-rotate' : '']">mdi-menu-up</v-icon>
          </div>
        </div>
        <template #actions>
          <v-switch
            @change="emitValue"
            inset
            color="primary"
            class="va-toggle-block--switch"
            :ripple="false"
            v-model="switchValue"></v-switch>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: "VaExpandableInput",
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
      subTitle: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        panelOpen: false,
        switchValue: false,
        isContentOpen: false,
      };
    },
    beforeMount() {
      this.switchValue = this.value ? true : false;
    },
    methods: {
      emitValue(val) {
        const emitValue = !!val;
        if (!emitValue) {
          this.panelOpen = false;
          this.isContentOpen = false;
        }
        this.$emit("input", !!val);
        this.$emit("change", !!val);
      },
      toggleContent() {
        /**
         * Expansion panels work by index, that's why setting the value to 0 opens the panel.
         */
        this.isContentOpen = !this.isContentOpen;
        this.panelOpen = this.isContentOpen ? 0 : false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-toggle-block {
    border: 1px solid get-color("border");
    background-color: get-color("element-bg-100") !important;
    border-radius: 6px;
    &--title {
      @include heading-4();
      color: get-color("headline");
      margin-bottom: 6px;
    }
    &--subtitle {
      @include text-subtitle-2();
      color: get-color("subtitle");
      margin-bottom: 6px;
    }
    &--action {
      @include text-button-medium();
      color: get-color("secondary-btn");
      display: inline-flex;
      align-items: center;
      width: 90px;
      cursor: pointer;
      .v-icon {
        transform: rotate(180deg);
        color: get-color("secondary-btn");
        transform-origin: center 12.5px;
        &.va-toggle-block--action-rotate {
          transform: rotate(0deg);
        }
      }
    }
    &--switch {
      margin-top: 0;
      padding: 0;
    }
    &::before {
      box-shadow: none !important;
    }
    &::v-deep {
      .v-expansion-panel-header {
        padding: 16px;
        cursor: default;
      }
      .v-expansion-panel-header__icon {
        align-self: baseline;
        margin: 0;
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }
  }

  .v-application.theme--light .v-expansion-panel.v-expansion-panel--active {
    box-shadow: none !important;
  }
</style>
